
export function isRegexSearch(search) {
    return typeof search === 'string' && search.startsWith('/') && search.endsWith('/');
}

export function matchesRegexPattern(file, pattern) {
    try {
        const regexStr = pattern.slice(1, -1);
        const regex = new RegExp(regexStr, 'i');
        return regex.test(file.name || '') || regex.test(file.path || '');
    } catch (e) {
        if (debugMode === '1') { console.error('Invalid regex pattern:', e); }
        return false;
    }
}

export function normalizeDateYMD(str) {
    if (!str || typeof str !== 'string') return null;
    const s = str.replace(/[\.\/]/g, '-').trim();
    let m;
    if ((m = s.match(/^\d{4}-\d{2}-\d{2}$/))) return s;
    if ((m = s.match(/^(\d{2})-(\d{2})-(\d{2})$/))) {
        const yy = parseInt(m[1], 10);
        const century = yy >= 50 ? 1900 : 2000;
        return `${century + yy}-${m[2]}-${m[3]}`;
    }
    if ((m = s.match(/^(\d{8})$/))) return `${s.slice(0,4)}-${s.slice(4,6)}-${s.slice(6,8)}`;
    if ((m = s.match(/^(\d{6})$/))) {
        const yy = parseInt(s.slice(0,2), 10);
        const century = yy >= 50 ? 1900 : 2000;
        return `${century + yy}-${s.slice(2,4)}-${s.slice(4,6)}`;
    }
    return null;
}

export function parseDateSafe(s) { const d = new Date(s); return isNaN(d) ? null : d; }


